import React, { useState, useEffect, useRef } from 'react';

import { /*reqGET, repo_img_link,*/ content_language, translate } from '../../../../Utils';

//import * as Hosts from "../../../../Hosts";

//import { language } from '../Language';

//import AssecImage from "../../ASSEC_Image/Image"

//import parse from 'html-react-parser';

import Loader from '../../../../loader';
import "./HomeLinks_01.css"

const HomeLinks = (props) => {

	const [, set_dados] = useState(null)
	const links_list = useRef([])
	const dados_config = useRef([])

    const [links_title, set_links_title] = useState('')
    const [links_subtitle, set_links_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [/*lang_id*/, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'connections' && el.info.active) {
                    set_links_title(translate(el.info.title, lang))
                    set_links_subtitle(translate(el.info.subtitle, lang))

                    set_dados(links_list.current = dados_config.current.content[0].connections)
                    setLoading(false)
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, [props, lang])

    return (
        isloading ?
            <Loader />
		:
            <section id="homelinks_01">
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties">
                            <h3 className="titulo-pp">
                                {links_title}
                            </h3>
                            {
                                links_subtitle !== '' ?
                                    <h4 className={"subtitulo-pp"}>
                                        {links_subtitle}
                                    </h4>
                                :
                                    null
                            }
                            <hr></hr>
                        </div>
                        {
                            links_list.current !== undefined && links_list.current !== null && links_list.current.length > 0 ?
                                <>
                                    <div className="col-12 col-xl-10 mx-auto">
                                        <div className="row g-3">
                                            {
                                                links_list.current.map((v, k) => {
                                                    return (
                                                        	
                                                        v.info.type !== undefined && v.info.type === 'link' ?
                                                            <div key={k} className='col-md-6 col-lg-4'>
                                                                {	
                                                                    v.info.link !== undefined && translate(v.info.link, 'pt') !== '' ?
                                                                        <a className="btn btn-download" href={translate(v.info.link, 'pt').includes('http') ? translate(v.info.link, 'pt') : 'http://' + translate(v.info.link, 'pt')} aria-label={"Link - " + translate(v.info.name, 'pt') + " (opens a new window)"} title={"Link - " + translate(v.info.name, 'pt')} target="_blank" rel="noreferrer" >
                                                                            {translate(v.info.name, 'pt')}
                                                                            <i className="bi bi-link-45deg fs-6 ps-2"></i>
                                                                        </a>
                                                                    :
                                                                        null
                                                                }
                                                            </div>
                                                        :

                                                            <div key={k} className='col-sm-6 col-md-4'>
                                                                {	
                                                                    v.info.link !== undefined && translate(v.info.link, 'pt') !== '' ?
                                                                        <a className="btn btn-download" href={translate(v.info.link, 'pt')} aria-label={"PDF - " + translate(v.info.name, 'pt') + " (opens a new window)"} title={"PDF - " + translate(v.info.name, 'pt')} target="_blank" rel="noreferrer" >
                                                                            {translate(v.info.name, 'pt')}
                                                                            <i className="bi bi-filetype-pdf fs-6 ps-2"></i>
                                                                        </a>
                                                                    :
                                                                        null
                                                                }
                                                            </div>
                                                        
                                                    )
                                                })              
                                            }
                                        </div>
                                    </div>
                                </> 
                            :
                            null
                        }
                    </div>
                </div>
            </section>
    )
};
export default HomeLinks;